import { render, staticRenderFns } from "./RCA.vue?vue&type=template&id=0b38eadd&scoped=true"
import script from "./RCA.vue?vue&type=script&lang=js"
export * from "./RCA.vue?vue&type=script&lang=js"
import style0 from "./RCA.vue?vue&type=style&index=0&id=0b38eadd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b38eadd",
  null
  
)

export default component.exports